import imgEmptyNoData from 'assets/images/img_emptyview_no_data.png';
import AgencyHelper, { AgencyConstants } from 'features/Agency/agencyHelper';
import ReconciliationReportHelper from 'features/ReconciliationReport/ReconciliationReportHelper';
import DialogEditReconciliationView from 'features/ReconciliationReport/SaleReconciliationReport/components/DialogEditReconciliationView';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import DropdownTableConfigColumn from 'general/components/DropdownTableConfigColumn';
import KTFormInput, {
    KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSButton, { KTBSButtonColor, KTBSButtonSize } from 'general/components/OtherKeenComponents/KTBSButton';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import KTPagination, { KTPaginationColor } from 'general/components/OtherKeenComponents/KTPagination';
import KTTable from 'general/components/OtherKeenComponents/KTTable';
import tableStyle from 'general/components/OtherKeenComponents/KTTable/tableStyle';
import EmptyView from 'general/components/Others/EmptyView';
import MenuActionDropdown from 'general/components/Others/MenuActionDropdown';
import FileUploadView from 'general/components/quybka/Uploads/FileUploadView';
import AppColors from 'general/constants/AppColors';
import AppConstants from 'general/constants/AppConstants';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Global from 'general/utils/Global';
import Utils from 'general/utils/Utils';
import useConfigTableColumn from 'hooks/useConfigTableColumn';
import useRouter from 'hooks/useRouter';
import JSZip from 'jszip';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import * as ExcelJS from 'exceljs';
import { ChargeConstants } from 'features/Charge/chargeHelper';
import SystemHelper, { SystemConstants } from 'features/System/systemHelper';

CoinvestorReconciliationTabView.propTypes = {
    agencyId: PropTypes.string,
};

const defaultColumnIds = [
    'RECONCILIATION_ID',
    'MONTH',
    'COINVESTOR_ID',
    'COINVESTOR_NAME',
    'ENERGY_CAR',
    'ENERGY_BIKE',
    'COINVESTOR_REVENUE',
    'STATUS',
    'DOCUMENT',
    'DATE',
    'ENERGY_AMOUNT',
    'PAID_ENERGY_AMOUNT',
    'TYPE',
];

function CoinvestorReconciliationTabView(props) {
    // MARK: ---- PROPERTIES ----
    const { showFullUI = false, agencyId } = props;
    const { t } = useTranslation();
    const router = useRouter();
    const { user } = useSelector((state) => state.auth);
    const [reconciliationList, setReconciliationList] = useState([]);
    const [total, setTotal] = useState([]);
    const [filter, setFilter] = useState(Global.g_filterCoinvestorReconciliationList);
    const adminRole =
        user?.role === AppConstants.userRole.admin || user?.role === AppConstants.userRole.operator;
    const [isReady, setIsReady] = useState(false);
    const [energyBillList, setEnergyBillList] = useState([]);
    useEffect(() => {
        const params = {
            month: filter?.month,
        }
        SystemHelper.API.EnergyBill.requestGetAll(params)
            .then((res) => {
                setEnergyBillList(res?.energyBills);
            })
            .catch((err) => { });
    }, [filter.month]);


    const fullColumns = useMemo(() => {
        return [
            {
                id: 'RECONCILIATION_ID',
                name: UIHelper.buildTableColumn('Mã đối soát'),
                selector: (row) => (
                    <span
                        className="cursor-pointer hover-opacity-60"
                        onClick={() => {
                            if (Utils.isValid(row?.document)) {
                                Utils.openInNewTab(Utils.getFullUrl(row?.document));
                            }
                        }}
                    >
                        {row?.reconciliationCode ?? row?.reconciliationId}
                    </span>
                ),
                width: '140px',
                style: tableStyle.columns.link,
            },
            {
                id: 'MONTH',
                name: UIHelper.buildTableColumn('Kỳ đối soát'),
                selector: (row) => Utils.formatDateTimeToString(row?.month, 'MM/yyyy'),
                width: '140px',
                style: tableStyle.columns.normal,
            },
            {
                id: 'COINVESTOR_ID',
                omit: !adminRole,
                name: UIHelper.buildTableColumn('Mã nhà đầu tư'),
                selector: (row) => row.agency?.agencyCode ?? row.agency?.agencyId,
                width: '140px',
                style: tableStyle.columns.normal,
            },
            {
                id: 'COINVESTOR_NAME',
                omit: !adminRole,
                name: UIHelper.buildTableColumn('Tên nhà đầu tư'),
                selector: (row) => (
                    <span
                        className="cursor-pointer hover-opacity-60"
                        onClick={() => {
                            AgencyHelper.Navigation.navigateToAgencyDetail(null, row?.agency);
                        }}
                    >
                        {row?.agency?.name}
                    </span>
                ),
                width: '240px',
                style: tableStyle.columns.link,
            },
            {
                id: 'ENERGY_AMOUNT',
                name: UIHelper.buildTableColumn('Tổng HĐ tiền điện trạm sạc sau thuế', 'VNĐ'),
                selector: (row) => Utils.formatNumber(Math.round(row?.metadata?.totalEnergyCost)) ?? 0,
                minWidth: '240px',
                right: true,
                style: tableStyle.columns.normal,
            },
            {
                id: 'PAID_ENERGY_AMOUNT',
                name: UIHelper.buildTableColumn('Tiền điện NĐT đã chi trả', 'VNĐ'),
                selector: (row) => {
                    const stations = (row?.metadata?.stations || []).filter(
                        item => item?.station?.isAgencyPayEnergyCost === 1
                    );

                    if (stations.length === 0) return 0;

                    const rawTotal = stations.reduce((total, stationData) => {
                        const bills = stationData?.station?.energyBills || [];

                        const stationSum = bills.reduce((sum, bill) => {
                            const eb = energyBillList?.find(
                                e => e?.billId === bill?.billId && e?.status === SystemConstants.EnergyBillStatus.VALIDATED
                            );

                            if (!eb) return sum;

                            const amount = Number(eb.amountBeforeTax) || 0;
                            const tax = Number(eb.taxRate) || 0;

                            return sum + amount * (1 + tax);
                        }, 0);

                        return total + (stationSum || 0);
                    }, 0);

                    return Utils.formatNumber(Math.round(rawTotal || 0));
                },
                minWidth: '200px',
                right: true,
                style: tableStyle.columns.normal,
            },
            {
                id: 'ENERGY_CAR',
                name: UIHelper.buildTableColumn('Sản lượng điện sạc ô tô', 'kWh'),
                selector: (row) => {
                    const energyCar = _.sumBy(
                        row?.metadata?.energyCommissionDetail?.filter(item => item.vehicleType === 'CAR'),
                        'totalEnergy'
                    ) ?? 0;
                    return Utils.formatNumber((energyCar / 1000)?.toFixed(3));
                },
                minWidth: '200px',
                right: true,
                style: tableStyle.columns.normal,
            },
            {
                id: 'ENERGY_BIKE',
                name: UIHelper.buildTableColumn('Sản lượng điện sạc xe máy', 'kWh'),
                selector: (row) => {
                    const energyBike = _.sumBy(
                        row?.metadata?.energyCommissionDetail?.filter(item => item.vehicleType === 'BIKE'),
                        'totalEnergy'
                    ) ?? 0;
                    return Utils.formatNumber((energyBike / 1000)?.toFixed(3));
                },
                minWidth: '200px',
                right: true,
                style: tableStyle.columns.normal,
            },
            {
                id: 'COINVESTOR_REVENUE',
                name: UIHelper.buildTableColumn('Doanh thu NĐT được nhận', 'VNĐ'),
                selector: (row) => Utils.formatNumber(row?.totalRevenue - row?.taxAmount ?? 0),
                minWidth: '200px',
                right: true,
                style: tableStyle.columns.normal,
            },
            {
                id: 'STATUS',
                name: UIHelper.buildTableColumn('Trạng thái'),
                selector: (row) => (
                    <KTLabel
                        text={ReconciliationReportHelper.getReconciliationStatusName(row?.status, 'COINVESTOR')}
                        isInline={true}
                        size={KTLabelSize.medium}
                        additionalClassName={`label-light-${ReconciliationReportHelper.getReconciliationStatusColor(
                            row?.status
                        )}`}
                    />
                ),
                minWidth: '140px',
                style: tableStyle.columns.normal,
            },
            {
                id: 'DOCUMENT',
                name: UIHelper.buildTableColumn('Tệp đính kèm'),
                selector: (row) => {
                    return row?.attachedFiles?.length > 0 ? (
                        <span
                            className="hover-opacity-60 cursor-pointer"
                            onClick={() => {
                                Utils.openInNewTab(row?.attachedFiles);
                            }}
                        >
                            {`Xem chi tiết`}
                        </span>
                    ) : (
                        <></>
                    );
                },
                width: '150px',
                style: tableStyle.columns.link,
            },
            {
                id: 'TYPE',
                name: UIHelper.buildTableColumn('Hình thức duyệt đối soát'),
                selector: (row) => ReconciliationReportHelper.getReconciliationTypeName(row?.reconciliationType ?? ''),
                width: '180px',
                style: tableStyle.columns.normal,
            },
            {
                id: 'DATE',
                name: UIHelper.buildTableColumn('Ngày tạo'),
                selector: (row) => (
                    <span>{Utils.formatDateTimeToString(row?.createdAt, 'DD/MM/YYYY')}</span>
                ),
                width: '120px',
                style: tableStyle.columns.normal,
            },
            {
                name: UIHelper.buildTableColumn('Thao tác'),
                width: '130px',
                style: {
                    position: 'sticky',
                    right: 0,
                    backgroundColor: '#fff',
                    borderLeft: '1px solid #ebedfe',
                },
                cell: (row) => {
                    return (
                        <MenuActionDropdown
                            menuAction={[
                                {
                                    iconElement: (
                                        <i
                                            className="fa-regular fa-eye"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: t('Xem chi tiết'),
                                    click: () => {
                                        router.navigate(`${row?.reconciliationId}#parent=coinvestor-reconciliation`);
                                    },
                                    show: true,
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="fa-regular fa-pen-to-square"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: t('edit'),
                                    click: () => {
                                        AppCustomDialogHelper.show(
                                            `Sửa đối soát tháng ${Utils.formatDateTimeToString(row?.month, 'MM/YYYY')}`,
                                            <DialogEditReconciliationView
                                                item={row}
                                                onCancel={() => {
                                                    AppCustomDialogHelper.hide();
                                                }}
                                                onDone={() => {
                                                    ToastHelper.showSuccess('Cập nhật đối soát thành công!')
                                                    AppCustomDialogHelper.hide();
                                                    handleGetCoinvestorReconciliationList();
                                                }}
                                            />,
                                            'md',
                                            true,
                                            true
                                        )
                                    },
                                    show: adminRole && (row?.reconciliationType === 'PAPER' && row?.status === 'COMPLETED'),
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="far fa-file-signature"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Duyệt & Ký đối soát',
                                    click: () => {
                                        ReconciliationReportHelper.handleAdminSignReconciliation(row, handleGetCoinvestorReconciliationList)
                                    },
                                    show: adminRole && row?.status === 'CREATED',
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="far fa-file-signature"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Ký đối soát',
                                    click: () => {
                                        ReconciliationReportHelper.handleAgencySignReconciliation(row, handleGetCoinvestorReconciliationList)
                                    },
                                    show: !adminRole && row?.status === 'ADMIN_SIGNED',
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="far fa-file-chart-column"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Xem file đối soát',
                                    click: () => {
                                        if (Utils.isValid(row?.document)) {
                                            Utils.openInNewTab(Utils.getFullUrl(row?.document));
                                        }
                                    },
                                    show: !!row?.document,
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="far fa-arrow-rotate-left"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Tạo lại đối soát',
                                    click: () => {
                                        AgencyHelper.UI.showDialogCreateReconciliation('COINVESTOR', row, handleGetCoinvestorReconciliationList)
                                    },
                                    show: adminRole
                                        && [
                                            AgencyConstants.AgencyReconciliationStatus.CREATED,
                                            AgencyConstants.AgencyReconciliationStatus.ADMIN_SIGNED,
                                        ].includes(row?.status),
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="far fa-receipt"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Xem hóa đơn tiền điện trạm sạc',
                                    click: () => {
                                        if (row?.invoiceLookup) {
                                            window.open(row.invoiceLookup, '_blank');
                                        }
                                    },
                                    show: !!row?.invoiceLookup,
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="far fa-download"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Tải đối soát excel',
                                    click: () => Utils.openInCurrentTab(row?.documentXLSX),
                                    show: !!row?.documentXLSX,
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="far fa-message-exclamation"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Gửi phản hồi',
                                    click: () => ReconciliationReportHelper.showDialogReconciliationFeedback(row, adminRole, handleGetCoinvestorReconciliationList),
                                    show: !adminRole && row?.status !== 'AGENCY_SIGNED',
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="far fa-message-exclamation"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Xem phản hồi',
                                    click: () => ReconciliationReportHelper.showDialogReconciliationFeedback(row, adminRole, handleGetCoinvestorReconciliationList),
                                    show: adminRole && !!row?.feedback,
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="far fa-file-check"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Duyệt hóa đơn thuế',
                                    click: () => ReconciliationReportHelper.showDialogApprovalInvoice(row, adminRole, handleGetCoinvestorReconciliationList),
                                    show: adminRole && row?.agency?.type === 'ORGANIZATION' && row?.status === 'AGENCY_SIGNED' && !!row?.attachedFiles?.length,
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="far fa-upload"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Tải lên hóa đơn thuế',
                                    click: () => ReconciliationReportHelper.showDialogUploadInvoiceDocument(row, handleGetCoinvestorReconciliationList),
                                    show: row?.agency?.type === 'ORGANIZATION' && row?.status === 'AGENCY_SIGNED',
                                },
                            ]}
                        />
                    )
                },
            }
        ];
    }, [user, adminRole, energyBillList]);

    const prefKey = useMemo(() => {
        const userId = user.userId;
        const pathName = router.pathname;
        const key = `${userId}_${pathName}`;
        return key;
    }, [user, router]);
    const [fullColumnIds, setFullColumnIds] = useState(
        fullColumns?.map((row) => row?.id).filter(Boolean) || []
    );
    const {
        columnIds,
        columns,
        onChangeCheckboxValue,
        saveChanges,
        resetDefaultTableColumn,
        onSelectAll,
        onUnSelectAll,
        fullColumnsSorted,
        fullColumnsIdSorted,
    } = useConfigTableColumn(prefKey, fullColumnIds, defaultColumnIds, fullColumns);

    useEffect(() => {
        handleGetCoinvestorReconciliationList();
    }, [user, filter]);

    // MARK: ---- METHODS ----

    const handleGetCoinvestorReconciliationList = () => {
        let paramGetReconciliationList = { ...Global.g_filterCoinvestorReconciliationList, primaryRole: 'COINVESTOR' };
        paramGetReconciliationList.agencyId = !adminRole ? user?.agency?.agencyId : '';
        if (adminRole || paramGetReconciliationList.agencyId) {
            AgencyHelper.API.requestGetReconciliationList(Utils.filterParams(paramGetReconciliationList))
                .then((data) => {
                    if (data) {
                        setReconciliationList(data?.reconciliations);
                        setTotal(data?.total);
                        setIsReady(true);
                    }
                })
        }
    }

    const handleViewFiles = (files) => {
        AppCustomDialogHelper.show(
            'Tệp đính kèm',
            <FileUploadView
                pathList={files}
                onCancel={() => {
                    AppCustomDialogHelper.hide();
                }}
            />,
            'md',
            false,
            true
        );
    };

    // xuat file excel
    const handleExportExcel = async (exportData, params) => {
        let exportDataList = exportData;
        if (_.isEmpty(exportDataList)) {
            ToastHelper.showError('Không có dữ liệu để tải xuống');
            return;
        }

        const zip = new JSZip();
        const sheetFileName = 'BBDS đầu tư_NĐT NQ_Tổng quan';
        const ext = '.xlsx';
        const folderName = 'BBDS đầu tư_NĐT NQ_Chi tiết';
        const zipFileName = `BBDS đầu tư_NĐT NQ_${Utils.formatDateTimeToString(params?.month, 'MMYYYY')}.zip`;

        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet(sheetFileName, {
            headerFooter: { firstHeader: sheetFileName },
        });

        sheet.mergeCells('A1:L1');
        sheet.getCell('A1').value = `BÁO CÁO ĐỐI SOÁT ĐẦU TƯ - NHÀ ĐẦU TƯ NHƯỢNG QUYỀN`;
        sheet.getCell('A1').font = {
            name: 'Times New Roman',
            family: 4,
            size: 11,
            bold: true,
            color: { argb: 'FFFFFFFF' },
        };
        sheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
        sheet.getCell('A1').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '29618E' },
            color: { argb: 'FFFFFF' },
        };
        sheet.getCell('A1').border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
        };
        sheet.getRow(1).height = 25;

        const columns = [
            { key: 'stt', width: 7 },
            { key: 'reconciliationCode', width: 18 },
            { key: 'month', width: 18 },
            { key: 'agencyCode', width: 18 },
            { key: 'agencyName', width: 35 },
            { key: 'totalEnergyCost', width: 40 },
            { key: 'totalEVNEnergyCost', width: 40 },
            { key: 'groupEnergyForCar', width: 35 },
            { key: 'groupEnergyForBike', width: 35 },
            { key: 'netAmount', width: 35 },
            { key: 'status', width: 20 },
            { key: 'date', width: 22 },
        ];
        sheet.columns = columns;

        sheet.getRow(2).height = 30;
        sheet.getRow(2).font = {
            name: 'Times New Roman',
            family: 4,
            size: 11,
            bold: true,
        };
        sheet.getRow(2).alignment = {
            vertical: 'middle',
            horizontal: 'center',
            wrapText: true,
        };

        sheet.getCell('A2').value = 'STT';
        sheet.getCell('B2').value = 'Mã đối soát';
        sheet.getCell('C2').value = 'Kỳ đối soát';
        sheet.getCell('D2').value = 'Mã nhà đầu tư';
        sheet.getCell('E2').value = 'Tên nhà đầu tư';
        sheet.getCell('F2').value = 'Tổng HĐ tiền điện trạm sạc sau thuế (VNĐ)';
        sheet.getCell('G2').value = 'Tiền điện NĐT đã chi trả (VNĐ)';
        sheet.getCell('H2').value = 'Sản lượng điện sạc ô tô (kWh)';
        sheet.getCell('I2').value = 'Sản lượng điện sạc xe máy (kWh)';
        sheet.getCell('J2').value = 'Doanh thu NĐT được nhận (VNĐ)';
        sheet.getCell('K2').value = 'Trạng thái';
        sheet.getCell('L2').value = 'Ngày tạo';

        ['A2:L2'].forEach((range) => {
            sheet.getRow(range.split(':')[0].slice(1)).eachCell({ includeEmpty: true }, (cell) => {
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' },
                };
            });
        });

        let i = 1;
        exportDataList?.forEach((row) => {
            const energyCar = _.sumBy(
                row?.metadata?.energyCommissionDetail?.filter(item => item.vehicleType === 'CAR'),
                'totalEnergy'
            ) ?? 0;
            const energyBike = _.sumBy(
                row?.metadata?.energyCommissionDetail?.filter(item => item.vehicleType === 'BIKE'),
                'totalEnergy'
            ) ?? 0;
            const dataRow = sheet.addRow({
                stt: i++,
                reconciliationCode: row?.reconciliationCode ?? row?.reconciliationId,
                month: Utils.formatDateTimeToString(row?.month, 'MM/yyyy'),
                agencyCode: row.agency?.agencyCode ?? row?.agency?.agencyId,
                agencyName: row?.agency?.name,
                totalEnergyCost: Utils.formatNumber(Math.round(row?.metadata?.totalEnergyCost)) ?? 0,
                totalEVNEnergyCost: '',
                groupEnergyForCar: Utils.formatNumber((energyCar / 1000)?.toFixed(3)),
                groupEnergyForBike: Utils.formatNumber((energyBike / 1000)?.toFixed(3)),
                netAmount: Utils.formatNumber(row?.netAmount ?? 0),
                status: ReconciliationReportHelper.getReconciliationStatusName(row?.status, 'COINVESTOR'),
                date: row?.createdAt ? Utils.formatDateTimeToString(row?.createdAt, 'DD/MM/YYYY - HH:mm') : '',
            });

            dataRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' },
                };
                if (colNumber === 1) {
                    cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                } else if (colNumber >= 6 && colNumber <= 10) {
                    cell.alignment = { vertical: 'middle', horizontal: 'right', wrapText: true };
                } else {
                    cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
                }
            });
        });

        sheet.eachRow((row, rowNumber) => {
            if (rowNumber >= 3) {
                row.font = {
                    name: 'Times New Roman',
                    family: 4,
                    size: 11,
                    bold: false,
                };
            }
        });

        const mainFileBuffer = await workbook.xlsx.writeBuffer();
        zip.file(`${sheetFileName}${ext}`, mainFileBuffer);

        const detailFolder = zip.folder(folderName);

        const fetchPromises = exportDataList?.map(async (row, index) => {
            if (row?.documentXLSX) {
                try {
                    const fileName = await Utils.getFileNameFromPath(row?.documentXLSX);
                    const file = await Utils.urlToFile(row?.documentXLSX, fileName);
                    const fileBuffer = await file.arrayBuffer();
                    const zipFileName = `${row?.reconciliationCode}_${Utils.formatDateTimeToString(params?.month, 'MMYYYY')}_BBDS đầu tư_NĐT NQ.company${ext}`;
                    detailFolder.file(zipFileName, fileBuffer);
                } catch (error) {
                    console.error(`Lỗi khi xử lý file ${row.documentXLSX}:`, error.message);
                    ToastHelper.showError(`Không tải được file ${row?.reconciliationCode ?? `item_${index + 1}`}: ${error.message}`);
                }
            }
        });

        await Promise.all(fetchPromises);

        try {
            const content = await zip.generateAsync({ type: 'blob' });
            const url = window.URL.createObjectURL(content);
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = zipFileName;
            anchor.click();
            window.URL.revokeObjectURL(url);
            ToastHelper.showSuccess('Tải xuống file ZIP thành công');
        } catch (error) {
            console.error('Lỗi khi tạo file ZIP:', error.message);
            ToastHelper.showError('Không thể tạo file ZIP');
        } finally {
            AppCustomDialogHelper.hide();
        }
    };

    return (
        <div className=''>
            {isReady && UIHelper.buildCard(
                <div>
                    {/* header */}
                    {showFullUI && (
                        <div className="px-4 pt-4 d-flex justify-content-between align-items-center">
                            {/* title */}
                            <div className="d-flex flex-column align-items-start">
                                <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                                    Danh sách đối soát
                                </span>
                                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                                    Tổng số:{' '}
                                    <span style={{ color: AppColors.primary }}>
                                        {total ?? reconciliationList?.length} {t('đối soát')}
                                    </span>
                                </span>
                            </div>

                            {/* actions */}
                        </div>
                    )}

                    {/* body */}
                    <div className="">
                        <div className='px-4'>
                            <span style={UIHelper.buildFontStyle('600', '16px', AppColors.gray[800])}> Tổng: </span>
                            <span style={UIHelper.buildFontStyle('600', '16px', AppColors.primary)}> {total} đối soát </span>
                            {/* <span style={{ color: AppColors.gray[500] }}> • </span>
                            <span style={UIHelper.buildFontStyle('600', '16px', AppColors.primary)}> VNĐ </span> */}
                        </div>
                        {/* filter */}
                        <div className="w-100 px-4 pb-4 d-flex align-items-end flex-wrap gap-3">
                            <div className="d-flex flex-wrap flex-grow-1 gap-3" style={{ minWidth: '0' }}>

                                {/* Tìm kiếm */}
                                <div className="flex-grow-1" style={{ minWidth: '280px' }}>
                                    {UIHelper.buildFormLabel('Tìm kiếm')}
                                    <KTFormSearch
                                        name="search"
                                        placeholder={"Theo mã đối soát, mã nhà đầu tư, tên nhà đầu..."}
                                        value={filter.q}
                                        onSubmit={(text) => {
                                            Global.g_filterCoinvestorReconciliationList = {
                                                ...Global.g_filterCoinvestorReconciliationList,
                                                q: text,
                                                page: 0,
                                            };
                                            setFilter(Global.g_filterCoinvestorReconciliationList);
                                        }}
                                    />
                                </div>

                                {/* Kỳ đối soát */}
                                <div className="flex-grow-1" style={{ minWidth: '200px' }}>
                                    {UIHelper.buildFormLabel('Kỳ đối soát')}
                                    <KTFormInput
                                        name="month"
                                        type={KTFormInputType.month}
                                        onChange={(value) => {
                                            Global.g_filterCoinvestorReconciliationList = {
                                                ...Global.g_filterCoinvestorReconciliationList,
                                                month: value,
                                                page: 0,
                                            };
                                            setFilter(Global.g_filterCoinvestorReconciliationList);
                                        }}
                                        value={filter.month}
                                        placeholder='MM/YYYY'
                                    />
                                </div>

                                {/* Trạng thái */}
                                <div className="flex-grow-1" style={{ minWidth: '200px' }}>
                                    {UIHelper.buildFormLabel('Trạng thái')}
                                    <KTBSDropdown
                                        name="status"
                                        toggleElement={
                                            <button
                                                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                                                type="button"
                                            >
                                                {ReconciliationReportHelper.filterStatusOptions('COINVESTOR').find(item => item.value === filter.status)?.name}
                                            </button>
                                        }
                                        selectedValue={filter.status}
                                        dropdownMenuItems={ReconciliationReportHelper.filterStatusOptions('COINVESTOR')}
                                        dropdownMenuClassName="overflow-auto w-100"
                                        dropdownMenuStyle={{ maxHeight: '30vh' }}
                                        onChange={(value) => {
                                            Global.g_filterCoinvestorReconciliationList = {
                                                ...Global.g_filterCoinvestorReconciliationList,
                                                status: value,
                                                page: 0,
                                            };
                                            setFilter(Global.g_filterCoinvestorReconciliationList);
                                        }}
                                        isDropdownForm={true}
                                    />
                                </div>
                            </div>

                            <div className="d-flex align-items-end gap-3 flex-shrink-0">
                                {/* Cấu hình cột */}
                                <div>
                                    <DropdownTableConfigColumn
                                        columnIds={columnIds}
                                        fullColumns={fullColumns}
                                        fullColumnIds={fullColumnsIdSorted}
                                        onChangeCheckboxValue={onChangeCheckboxValue}
                                        saveChanges={saveChanges}
                                        resetDefaultTableColumn={() => {
                                            setFullColumnIds(defaultColumnIds);
                                            resetDefaultTableColumn();
                                        }}
                                        onChangeFullColumnIds={(ids) => {
                                            setFullColumnIds(ids);
                                            const key = prefKey + '_FULL_COLUMN_IDS';
                                            localStorage.setItem(key, ids.join('|'));
                                        }}
                                        onSelectAll={onSelectAll}
                                        onUnSelectAll={onUnSelectAll}
                                    />
                                </div>

                                {adminRole && (
                                    <>
                                        <div>
                                            {UIHelper.buildBlueButton(
                                                'Tải xuống',
                                                async () => { },
                                                <i className="far fa-download" style={{ color: '#FFFFFF', fontSize: 15 }} />
                                            )}
                                        </div>
                                        <div>
                                            {UIHelper.buildBlueButton(
                                                'Tạo lại đối soát',
                                                () => {
                                                    AgencyHelper.UI.showDialogCreateReconciliation('COINVESTOR', null, handleGetCoinvestorReconciliationList)
                                                },
                                                <i className="far fa-arrow-rotate-left" />
                                            )}
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>

                        {/* table */}
                        <div className="px-4">
                            <KTTable
                                columns={columns}
                                items={reconciliationList}
                                selectableRows={false}
                                striped={false}
                                compactGrid={false}
                                onClickedRow={(row) => { }}
                                onSelectedRowsChanged={(rows) => { }}
                                onDoubleClickedRow={(rows) => { }}
                                noDataComponent={
                                    <EmptyView
                                        icon={imgEmptyNoData}
                                        title="Không có dữ liệu để hiển thị"
                                        text={<span>Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.</span>}
                                    />
                                }
                            />
                        </div>

                        {/* phan trang */}
                        <div className={`mt-4 px-4 ${!agencyId ? 'mb-4' : ''}`}>
                            <KTPagination
                                currentPage={filter.page + 1}
                                rowCount={total != 0 ? total : reconciliationList?.length}
                                rowsPerPage={filter.limit}
                                currentItemInPageCount={reconciliationList?.length}
                                onChangePage={(newPage) => {
                                    const iNewPage = parseInt(newPage);
                                    if (!!agencyId) {
                                        handleFilterChanged({
                                            page: iNewPage - 1,
                                        });
                                    } else {
                                        Global.g_filterCoinvestorReconciliationList = {
                                            ...Global.g_filterCoinvestorReconciliationList,
                                            page: iNewPage - 1,
                                        };
                                        setFilter(Global.g_filterCoinvestorReconciliationList);
                                    }
                                }}
                                onChangeRowsPerPage={(newRowsPerPage) => {
                                    const iNewRowsPerPage = parseInt(newRowsPerPage);
                                    if (!!agencyId) {
                                        handleFilterChanged({
                                            limit: iNewRowsPerPage,
                                            page: 0,
                                        });
                                    } else {
                                        Global.g_filterCoinvestorReconciliationList = {
                                            ...Global.g_filterCoinvestorReconciliationList,
                                            limit: iNewRowsPerPage,
                                            page: 0,
                                        };
                                        setFilter(Global.g_filterCoinvestorReconciliationList);
                                    }
                                }}
                                color={KTPaginationColor.success}
                                appendText="đối soát"
                            />
                        </div>
                    </div>
                </div>,
                false,
                !showFullUI
            )}
        </div>
    );
}

export default CoinvestorReconciliationTabView;
